import React from "react";
import { Box, Button, FormLabel, Typography } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import * as actions from "../../../../actions/actions";
import CustomizedSnackbars from "../../../../components/Toast";

const MAX_LENGTH = 250;

const SessionNotesTab = ({ sessionId, event, raceSessionsDate }) => {
  const dispatch = useDispatch();
  const [notes, setNotes] = React.useState("");
  const [snackbar, setSnackbar] = React.useState({ text: "", severity: "" });

  const initialNotes = useSelector(
    (state) => state.raceSessionNotes.raceSessionNotes.data
  );

  React.useEffect(() => {
    dispatch(actions.fetchRaceSessionForNotes(sessionId));
  }, [sessionId]);

  React.useEffect(() => {
    setNotes(initialNotes.sessionNotes || "");
  }, [initialNotes]);

  const showToast = (text, severity) => {
    setSnackbar({ text, severity });
    setTimeout(() => setSnackbar({ text: "", severity }), 2500);
  };

  const handleSave = async () => {
    try {
      const response = await dispatch(
        actions.createUpdateRaceSessionNotes({
          raceSessionId: sessionId,
          sessionNotes: notes,
        })
      );
      if (!response.status) {
        showToast(response.data.message, "error");
      } else {
        showToast("Notes saved successfully!", "success");
      }
    } catch {
      showToast("Couldn't save the notes", "error");
    }
  };

  return (
    <Box>
      <CustomizedSnackbars
        severity={snackbar.severity}
        open={snackbar.text !== ""}
        setShowToast={() => setSnackbar({ text: "", severity: "" })}
        text={snackbar.text}
      />

      {/* NOTES label */}
      <FormLabel
        sx={{
          display: "block",
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: 0.6,
          textTransform: "uppercase",
          color: "var(--ty-secondary-color, #42566c)",
          mb: 1,
        }}
      >
        Notes
      </FormLabel>

      {/* Textarea */}
      <textarea
        autoFocus
        value={notes}
        onChange={(e) => {
          setNotes(e.target.value.slice(0, MAX_LENGTH));
        }}
        placeholder="Add notes about this race session..."
        rows={8}
        style={{
          width: "100%",
          resize: "none",
          boxSizing: "border-box",
          padding: "12px 14px",
          fontSize: 13,
          color: "var(--ty-secondary-color, #42566c)",
          border: "1.5px solid #c8dce8",
          borderRadius: "10px",
          outline: "none",
          fontFamily: "inherit",
          backgroundColor: "#ffffff",
          lineHeight: 1.6,
        }}
        onFocus={(e) => (e.target.style.borderColor = "var(--ty-primary-color, #356dad)")}
        onBlur={(e) => (e.target.style.borderColor = "#c8dce8")}
      />

      {/* Counter + Save row */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mt: 1,
        }}
      >
        <Typography
          sx={{
            fontSize: 12,
            color: "#8a9fb5",
          }}
        >
          {notes.length}/{MAX_LENGTH}
        </Typography>

        <Button
          variant="contained"
          onClick={handleSave}
          sx={{
            bgcolor: "var(--ty-primary-color, #356dad)",
            color: "#fff",
            borderRadius: "20px",
            textTransform: "none",
            fontWeight: 600,
            fontSize: 12,
            px: 3.5,
            py: 0.5,
            boxShadow: "none",
            "&:hover": {
              bgcolor: "var(--ty-primary-hovercolor, #2b598d)",
              boxShadow: "none",
            },
          }}
        >
          Save
        </Button>
      </Box>
    </Box>
  );
};

export default SessionNotesTab;
